import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-magma-dom';

import Content from './Content';

const DownloadDatasetModalContainer = ({ isOpen, onCloseModal }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCloseModal}
      header="Download"
    >
      <Content />
    </Modal>
  );
};

DownloadDatasetModalContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default DownloadDatasetModalContainer;
